import {
  UPDATE_TASK_TEMPLATE_USER_REQUEST_PAGE_NUMBER,
  GET_TASK_TEMPLATE_USER_REQUEST_PENDING,
  GET_TASK_TEMPLATE_USER_REQUEST,
  DELETE_TASK_TEMPLATE_USER_REQUEST,
  FETCH_TASK_TEMPLATE_USER_REQUEST,
  EDIT_TASK_TEMPLATE_USER_REQUEST,
  ADD_TASK_TEMPLATE_USER_REQUEST,
  CLEAR_TASK_TEMPLATE_USER_REQUEST,
  RESET_TASK_TEMPLATE_USER_REQUEST,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  task_template_user_request: [],
  updated: false,
  pageNumber: 1,
  pending: false,
};

export default function TaskTemplateUserTask(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TASK_TEMPLATE_USER_REQUEST_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
        pending: false,
        updated: false,
      };
    case GET_TASK_TEMPLATE_USER_REQUEST_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        task_template_user_request: action.payload,
        pending: false,
      };
    case FETCH_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case EDIT_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case DELETE_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case ADD_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case RESET_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        updated: false,
      };
    case CLEAR_TASK_TEMPLATE_USER_REQUEST:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
